import {
    ADD_PRODUCT_IMAGE,
    ADD_PRODUCT_IMAGE_FAILURE,
    ADD_PRODUCT_IMAGE_SUCCESS,
} from 'store/actions/types';

export const addProductImage = (payload) => {
    return {
        type: ADD_PRODUCT_IMAGE,
        payload: payload,
    };
};

export const addProductImageFailure = (error) => {
    return {
        type: ADD_PRODUCT_IMAGE_FAILURE,
        error: error,
    };
};

export const addProductImageSuccess = (productId, response) => {
    return {
        type: ADD_PRODUCT_IMAGE_SUCCESS,
        productId,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/products/images/addImage.js